import { FC } from 'react'
import Svg from '@/public/images/common/x-close_v2.svg'
import classNames from 'classnames'
import styles from './index.module.scss'

type Props = {
  onClick: () => void
  size?: 'sm' | 'md' | 'lg'
}

export const TagClose: FC<Props> = ({ onClick, size = 'md' }) => {
  return (
    <button
      type='button'
      className={classNames(styles.container, {
        [styles.sm]: size === 'sm',
        [styles.md]: size === 'md',
        [styles.lg]: size === 'lg',
      })}
      onClick={onClick}
    >
      <Svg viewBox='0 0 24 24' />
    </button>
  )
}
